import BoxState from '../../scripts/lib/box-state.js'

class ProductBuyBox extends HTMLElement {
  #boxState = null
  #quantityComponent = null
  #addButton = null
  #formEl = null
  #currentVariantId = null
  #variantEventTarget = null
  #boundHandleVariantChange = null

  constructor() {
    super()
    this.handleAddToBox = this.handleAddToBox.bind(this)
    this.#boundHandleVariantChange = this.#handleVariantChange.bind(this)
  }

  connectedCallback() {
    this.#boxState = BoxState.getInstance()
    this.#cacheElements()
    this.#currentVariantId = this.dataset.variantId
    this.setupEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  #cacheElements() {
    this.#quantityComponent = this.querySelector('v-quantity')
    this.#addButton = this.querySelector('[data-add-to-box]')

    const formId = this.dataset.formId
    if (formId) {
      this.#formEl = document.getElementById(formId)
    }
  }

  setupEventListeners() {
    if (this.#addButton) {
      this.#addButton.addEventListener('click', this.handleAddToBox)
    }

    this.#variantEventTarget = this.#formEl || this.closest('.product-info, .shopify-section')

    if (!this.#variantEventTarget && this.hasAttribute('data-is-gift-card')) {
      console.error('[product-buy-box] Cannot find variant event target for gift card. Form ID:', this.dataset.formId)
    }

    this.#variantEventTarget?.addEventListener('variant:change', this.#boundHandleVariantChange)
  }

  removeEventListeners() {
    if (this.#addButton) {
      this.#addButton.removeEventListener('click', this.handleAddToBox)
    }

    this.#variantEventTarget?.removeEventListener('variant:change', this.#boundHandleVariantChange)
    this.#variantEventTarget = null
  }

  #handleVariantChange(event) {
    const { variant } = event.detail
    if (variant?.id) {
      this.#currentVariantId = variant.id
    }
  }

  handleAddToBox() {
    const variantId = this.#getSelectedVariantId()
    const quantity = parseInt(this.#quantityComponent?.dataset.value || '1', 10)

    if (this.hasAttribute('data-is-gift-card')) {
      const rootPath = window.Shopify?.routes?.root || '/'
      window.location.href = `${rootPath}cart/${variantId}:${quantity}`
      return
    }

    this.#boxState.clearSamplerStep()

    this.#boxState.setBoxItem(variantId, { quantity })

    const collection = this.dataset.collection
    const url = collection && collection !== 'all' ? `/cart?tab=${collection}` : '/cart'
    window.location.href = url
  }

  #getSelectedVariantId() {
    if (this.#currentVariantId) {
      return this.#currentVariantId
    }

    if (this.#formEl) {
      const hiddenInput = this.#formEl.querySelector('input[name="id"]')
      if (hiddenInput && hiddenInput.value) {
        return hiddenInput.value
      }
    }

    return this.dataset.variantId
  }
}

if (!customElements.get('product-buy-box')) {
  customElements.define('product-buy-box', ProductBuyBox)
}

export default ProductBuyBox